module.exports = __webpack_public_path__ + "img/valuation.b8fc16f6.jpg";